// src/components/watch/Watch.js
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import WatchGrid from "./WatchGrid";
import WatchDetail from "./watchDetail/WatchDetail";
import Filters from "./Filters";
import { getLiveRaces } from "../../services/watchServices";
import "./Watch.css";
import WatchHeader from "./Header";

const Watch = ({ onPlaceBet }) => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedRace, setSelectedRace] = useState(null);

  useEffect(() => {
    const fetchGames = async () => {
      try {
        setLoading(true);
        const data = await getLiveRaces();
        setGames(data);
      } catch (err) {
        console.error("Error fetching live races:", err);
        setError("Failed to load live races");
      } finally {
        setLoading(false);
      }
    };

    fetchGames();
    // Set up polling for live updates
    const interval = setInterval(fetchGames, 30000); // Update every 30 seconds

    return () => clearInterval(interval);
  }, []);

  const handleWatchRace = (race) => {
    setSelectedRace(race);
  };

  const handleBack = () => {
    setSelectedRace(null);
  };

  if (loading) {
    return (
      <div className="race-grid-loading">
        <div className="loading-spinner"></div>
        <p>Loading live races...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="race-grid-error">
        <p>{error}</p>
        <button
          onClick={() => window.location.reload()}
          className="retry-button"
        >
          Retry
        </button>
      </div>
    );
  }

  // Show detail view when a race is selected
  if (selectedRace) {
    return (
      <div className="watch-container">
        <WatchDetail
          race={selectedRace}
          onBack={handleBack}
          onPlaceBet={onPlaceBet}
        />
      </div>
    );
  }

  // Show grid view
  return (
    <div className="watch-container">
      <WatchHeader />
      <Filters onFilter={(filters) => console.log(filters)} />
      <WatchGrid
        games={games}
        onPlaceBet={onPlaceBet}
        onWatchRace={handleWatchRace} // New prop for handling watch clicks
      />
    </div>
  );
};

Watch.propTypes = {
  onPlaceBet: PropTypes.func,
};

Watch.defaultProps = {
  onPlaceBet: () => { },
};

export default Watch;
